import React, { useMemo } from 'react';

import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import Loading from 'core/Loading';
import { useExperienceModuleContext } from 'modules/experience-core';
import { useSelectedEntityVenues } from 'modules/experience-core';
import { ExperienceEntityType } from 'modules/experience-core';

import InsightRoutes from '../InsightRoutes';
import useInsightV2WoltPlusHidden from '../hooks/useInsightV2WoltPlusHidden';
import { InsightEntity } from '../types';

const ExperienceInsights = () => {
  const { experienceEntity, selectedExperienceEntity, country, isWoltPlus } = useExperienceModuleContext();

  const venueExperienceEntities = useSelectedEntityVenues();
  const venues: Venue[] = useMemo(() => {
    return experienceEntity.experienceEntityType === ExperienceEntityType.VENUE
      ? [experienceEntity.experienceEntityObject]
      : venueExperienceEntities.map(venue => venue.experienceEntityObject);
  }, [experienceEntity, venueExperienceEntities]);

  const { isWoltPlusHidden, isLoading: isLoadingWoltPlusHidden } = useInsightV2WoltPlusHidden(country);
  const insightEntity: InsightEntity = useMemo(
    () => ({
      type: selectedExperienceEntity.experienceEntityType as any,
      id: selectedExperienceEntity.experienceEntityId,
      isWoltPlus: !isWoltPlusHidden && isWoltPlus,
      venue: venues[0],
      venues,
      merchant: selectedExperienceEntity.experienceEntityObject as Merchant,
    }),
    [selectedExperienceEntity, venues, isWoltPlus, isWoltPlusHidden],
  );

  if (isLoadingWoltPlusHidden) {
    return <Loading />;
  }

  return <InsightRoutes isExperienceFlow insightEntity={insightEntity} />;
};

export default ExperienceInsights;
